<template>
  <div :class="menu_class" :id="id">
    <ul class="navbar-nav">
      <li v-for="(item, index) in items" :key="index" class="nav-item">
        <div v-if="item.children" class="dropdown">
          <button type="button" data-toggle="dropdown" class="link-content">
            <a v-if="item.url !== ''" :href="item.url" v-html="item.title" />
            <a v-else v-html="item.title" />
          </button>
          <div v-if="item.children" class="dropdown-menu subnav menu_dropdown_list">
            <a
              v-for="(subitem, subindex) in item.children"
              :key="subindex"
              :href="subitem.url"
              class="submenu_item"
              @click="eventEmitter('submenu_clicked')"
            >
              <span v-html="subitem.title" />
            </a>
          </div>
        </div>
        <div v-else class="link-content a-link-display">
          <a :href="item.url" class="single-link submenu_item" v-html="item.title" />
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "fcwpMenu",
  props: ["menu_class", "items", "id"],
  methods: {
    eventEmitter(event) {
      this.$root.$emit(event);
    }
  }
};
</script>

<style lang="scss">
.menu {
  width: 28vw;
  -ms-flex-item-align: start; //przemieszcza caly blok na samą górę strony
  align-self: flex-start;
  line-height: 1;
  margin-top: 0;
  z-index: 1500;
  .link-content {
    @media (min-width: 1200px) {
      font-size: 1.5vw;
      margin: 0 0.3vw;
      :before {
        margin-left: 1.05vw;
      }
    }
  }

  ul {
    margin: 3vw 0 0 0;
  }
  a {
    text-transform: uppercase;
    font-weight: 500;
    color: rgb($quinary-color);
    display: flex;
    text-align: left;
  }
  a:hover {
    color: rgb($quinary-color);
  }
  .a-link-display {
    display: inline-block;
  }

  .menu_dropdown_list {
    position: relative;
    background-color: rgba(48, 62, 71, 0.9);
    border-radius: 0rem;
    width: 200%;
    margin-top: 0.3vw;
    max-width: 15vw;
    padding: 0.2vw 0.3vw 0.5vw;
    z-index: 1300;
    left: 1.8vw;
    line-height: 1.5;
    a {
      font-size: 1.25vw;
      display: block;
      padding: 0vw 0.3vw;
      color: rgb($quaternary-color);
    }
    span:hover {
      color: rgb($primary-color);
      background-color: rgb($quaternary-color);
    }
  }
}

.jumbotron-image .menu a,
.jumbotron-video .menu a,
.jumbotron-image .menu a:hover,
.jumbotron-video .menu a:hover {
  color: rgb($septenary-color);
}

.jumbotron-image .menu button,
.jumbotron-video .menu button,
.jumbotron-image .menu .single-link,
.jumbotron-video .menu .single-link {
  text-shadow: 0px 0px 3px rgba(48, 62, 71, 1);
}

.jumbotron-image .menu_dropdown_list,
.jumbotron-video .menu_dropdown_list {
  background-color: rgba(48, 62, 71, 0.6);
}

#menu_right {
  margin-right: 0.5vw;
}

#menu_right .menu_dropdown_list {
  left: initial;
  right: 0;
}

#menu_left ul.navbar-nav {
  margin-left: auto;
}

@media (max-width: 1199px) {
  #menu_left {
    margin-top: 30px;
  }
  .menu {
    width: auto;
    line-height: 1.3;
    margin-top: 0;
    margin-left: 50px;
    display: table-row;
    ul {
      margin-top: 0;
    }
    .menu_dropdown_list {
      width: fit-content;
      margin-right: 9vw;
      margin-left: 40px;
      line-height: 1.3;
      padding: 3px;
      max-width: none;
      a {
        font-size: 18pt;
      }
    }
  }
}

@media (max-width: 700px) {
  .menu {
    margin-left: unset;
    .menu_dropdown_list {
      margin-right: 58px;
      margin-left: 25px;
      a {
        font-size: 15pt;
        padding: 2px;
      }
    }
  }
}
</style>

